/**
 * /settings/phone-numbers — LEGACY route, now a redirect (QA B-4 / G-6).
 *
 * settings-v2 is the canonical Settings area. This surface still exists as
 * a pane there (Admin → Phone numbers), so the standalone route redirects
 * instead of rendering a second, parallel settings shell. Links minted
 * before the consolidation keep working.
 *
 * The page component itself is NOT deleted: `phone-numbers.lazy.tsx` still exports
 * it, and settings-v2-area-v3.tsx mounts that export. Redirecting in
 * `beforeLoad` means the lazy chunk is never even fetched for a direct hit.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/phone-numbers')({
  beforeLoad: () => {
    throw redirect({ to: '/settings-v2', search: { tab: 'phone-numbers' }, replace: true });
  },
});
